<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="flex items-center"
              v-if="!modeTemplate"
            >
              <input
                class='k-checkbox !mr-2 checkbox-lg'
                type='checkbox'
                v-model="checkall"
                @click="changeAllCheckbox(!checkall)"
              />
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block">{{$t('app.check_all_fields')}}</label>
            </div>

            <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('companies.group_company_data')}}</h3>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Telefono"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.telefono')}}
                    </label>
                  </div>
                  <el-form-item prop="Telefono">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Telefono"
                      maxlength='15'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Activo"
                />
                <el-switch 
                  class="switch-text break-normal" 
                  v-model="form.Activo" 
                  :active-text="$t('app.active')"/>
              </div>
            </div>

            <h3 class="dark:text-darkblue-200 font-bold mt-6 mb-4">{{$t('address.header')}}</h3>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Direccion"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.location')}}
                    </label>
                  </div>
                  <el-form-item prop="Direccion">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Direccion"
                      maxlength='80'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.CodigoPostal"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.codigo_postal')}}
                    </label>
                  </div>
                  <el-form-item prop="CodigoPostal">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.CodigoPostal"
                      maxlength='9'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Poblacion"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.poblacion')}}
                    </label>
                  </div>
                  <el-form-item prop="Poblacion">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.Poblacion"
                      maxlength='50'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Provincia"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.provincia')}}
                    </label>
                  </div>
                  <el-form-item prop="Provincia">
                    <el-input v-if="!isSpain"
                      clearable
                      class="w-full"
                      v-model="form.Provincia"
                      maxlength='20'
                    />
                    <el-select v-else
                      class="w-full" 
                      v-model="form.Provincia" 
                      filterable
                      clearable 
                      :placeholder="$t('app.select')">
                      <el-option
                        v-for="opt in listProvincias"
                        :key="opt.id"
                        :label="opt.name"
                        :value="opt.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.Pais"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('address.pais')}}
                    </label>
                  </div>
                  <el-form-item prop="Pais">
                    <base-el-select 
                      class="w-full" 
                      :options="listPaises" 
                      v-model="form.Pais" 
                      filterable 
                      />
                  </el-form-item>
                </div>
              </div>
            </div>

            <h3 class="dark:text-darkblue-200 font-bold mb-4">{{$t('avisos.header')}}</h3>
          
           <div class="mt-2 mb-4">
              <div class="mandatory flex items-center mb-4">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.EnviarAvisos"
                />
                <el-switch class="switch-text break-normal" v-model="form.EnviarAvisos" :active-text="$t('app.active')"></el-switch>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.EmailAvisoNuevaEmitida"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_nueva_emitida')}}
                    </label>
                    <el-switch 
                      v-if="!modeTemplate"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="valuesAdd.EmailAvisoNuevaEmitida" 
                      :inactive-text="$t('app.add')"
                      :active-text="$t('configurations.sustitute')" 
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                  <el-form-item prop="EmailAvisoNuevaEmitida">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoNuevaEmitida"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.EmailAvisoNuevaRecibida"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_nueva_recibida')}}
                    </label>
                    <el-switch 
                      v-if="!modeTemplate"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="valuesAdd.EmailAvisoNuevaRecibida" 
                      :inactive-text="$t('app.add')"
                      :active-text="$t('configurations.sustitute')" 
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                  <el-form-item prop="EmailAvisoNuevaRecibida">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoNuevaRecibida"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.EmailAvisoCambioEstado"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_cambio_estado')}}
                    </label>
                    <el-switch 
                      v-if="!modeTemplate"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="valuesAdd.EmailAvisoCambioEstado" 
                      :inactive-text="$t('app.add')"
                      :active-text="$t('configurations.sustitute')" 
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                  <el-form-item prop="EmailAvisoCambioEstado">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailAvisoCambioEstado"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>

            <div class="lg:mb-2">
              <div class="mandatory flex items-center">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.EmailTecnico"
                />
                <div class="w-full">
                  <div class="flex items-center justify-between">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('companies.email_tech')}}
                    </label>
                    <el-switch 
                      v-if="!modeTemplate"
                      class="switch-text break-normal both-switch mt-2" 
                      v-model="valuesAdd.EmailTecnico" 
                      :inactive-text="$t('app.add')"
                      :active-text="$t('configurations.sustitute')" 
                      inactive-color="var(--primary-800)"
                      />
                  </div>
                  <el-form-item prop="EmailTecnico">
                    <el-input
                      clearable
                      class="w-full"
                      v-model="form.EmailTecnico"
                      maxlength='500'
                    />
                  </el-form-item>
                </div>
              </div>
            </div>
          
            <h3 class="dark:text-darkblue-200 font-bold mb-4">{{$t('companies.configuration.pge_header')}}</h3>

            <base-collapsible-form ref="baseCollapsibleFace"
              class="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
              <template slot="headerRight">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">
                  {{ $t('companies.configuration.status_change_email') }}
                </h3>
              </template>
              <template slot="content">

                <div class="lg:mb-2">
                  <div class="mandatory flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg !mb-4'
                      type='checkbox'
                      v-model="valuesCheckbox.FaceEmail"
                    />
                    <div class="w-full">
                      <el-form-item prop="FaceEmail">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.FaceEmail"
                          maxlength='500'
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>
                
                <div class="mb-4">
                  <div class="flex flex-row items-center mb-4 lg:mb-0">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.FaceRecuperarEmail"
                    />
                    <el-switch 
                      class="switch-text break-normal" 
                      v-model="form.FaceRecuperarEmail" 
                      :active-text="$t('companies.configuration.facturae_recover_mail')"/>
                  </div>
                </div>

              </template>
            </base-collapsible-form>
            
            <!-- <base-collapsible-form ref="baseCollapsibleTuComunidad"
              class="mt-2 bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border pr-4 pl-4">
              <template slot="headerRight">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('tipos.pge.tucomunidad') }}</h3>
              </template>
              <template slot="content">

                <div class="lg:mb-2">
                  <div class="mandatory flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.TuComunidadUsuario"
                    />
                    <div class="w-full">
                      <div class="flex items-center justify-between">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('users.entity_name')}}
                        </label>
                      </div>
                      <el-form-item prop="TuComunidadUsuario">
                        <el-input
                          clearable
                          class="w-full"
                          v-model="form.TuComunidadUsuario"
                          maxlength='50'
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>

                <div class="lg:mb-2">
                  <div class="mandatory flex items-center">
                    <input
                      v-if="!modeTemplate"
                      class='k-checkbox !mr-2 checkbox-lg'
                      type='checkbox'
                      v-model="valuesCheckbox.TuComunidadPassword"
                    />
                    <div class="w-full">
                      <div class="flex items-center justify-between">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">{{$t('users.password')}}
                        </label>
                      </div>
                      <el-form-item prop="TuComunidadPassword">
                        <el-input
                          clearable
                          show-password
                          class="w-full"
                          v-model="form.TuComunidadPassword"
                          autocomplete="new-password" 
                          maxlength='50'
                        />
                      </el-form-item>
                    </div>
                  </div>
                </div>

              </template>
            </base-collapsible-form> -->

            <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-4">{{ $t('companies.configuration.config_firma') }}</h3>
            
            <div class="mb-4">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.FirmarFacturae"
                />
                <el-switch 
                  class="switch-text break-normal" 
                  v-model="form.FirmarFacturae" 
                  :active-text="$t('companies.configuration.config_firma_facturae')"/>
              </div>
            </div>
            
            <div class="mb-4">
              <div class="flex flex-row items-center mb-4 lg:mb-0">
                <input
                  v-if="!modeTemplate"
                  class='k-checkbox !mr-2 checkbox-lg'
                  type='checkbox'
                  v-model="valuesCheckbox.FirmarAdjuntosExternos"
                />
                <el-switch 
                  class="switch-text break-normal" 
                  v-model="form.FirmarAdjuntosExternos" 
                  :active-text="$t('companies.configuration.config_firma_adjuntos')"/>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="isFromClient ? $t('app.cancel') : $t('app.back')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="enableEditCampos" mode="primary" :forceIcon="true" :text="!modeTemplate ? $t('configurations.change_mode_template') : $t('app.edit_fields')" @click="toggleModeTemplate()"  icon="refresh" :loading="isGeneralLoading"/>
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('configurations.link_template_to_entity', { entity })" @click="toggleDialogLink"  icon="link" :loading="isGeneralLoading"/>
          <base-button-responsive 
            v-if="!modeTemplate" 
            mode="primary" 
            :text="$t('configurations.apply_to_entity', { entity })" 
            @click="toggleDialogLink"  
            icon="link" 
            :loading="isGeneralLoading"
            v-popover:popover
          />
          <base-button-responsive v-if="modeTemplate" mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')" :loading="isGeneralLoading" :disabled="isGeneralLoading"/>
          <el-popover
            ref="popover"
            placement="top"
            width="250"
            v-model="showPopoverRedirection"
            popper-class="dark:bg-darkblue dark:border-darkblue-600 dark:text-darkblue-200"
            trigger="manual"
          >
            <div v-safe-html="$t('app.preselected_entities_f', { entity })" />
          </el-popover>
        </template>
      </base-footer>
      <template-link-Companies-dialog
        ref="reftemplatelinkcompaniesdialog" 
        :title="titleLinkCompanies" 
        :clientId="this.id" 
        :modeTemplate="modeTemplate" 
        :dialogOpen="linkToCompaniesDialog" 
        @toggleDialog="toggleDialogLink" 
        @applyDialog="applyLinkHandler" />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { getCompanyTemplate } from '@/services/app/getCompanyTemplate'
import { updateCompanyTemplate } from '@/services/app/updateCompanyTemplate'
import { applyCompanyTemplate } from '@/services/app/applyCompanyTemplate'
import { applyCompanyKeys } from '@/services/app/applyCompanyKeys'
import { i18n } from '@/i18n'
import { email as emailRegex } from '@/utils/regex'
import DetailLayoutFullWidth from '../../components/layout/DetailLayoutFullWidth.vue'
import TemplateLinkCompaniesDialog from '@/components/TemplateLinkCompaniesDialog.vue'

import { getClient } from '@/services/clients/getClient'

function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}

function isValidEmailSingle (value) {
  return emailRegex.test(value)
}

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayoutFullWidth,
    TemplateLinkCompaniesDialog,
  },
  data: function () {
    return {
      modeTemplate: true,
      showPopoverRedirection: false,
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      enableEditCampos: true,
      searchView: false,
      linkToCompaniesDialog: false,
      activeName: 'es',
      entity: i18n.tc('companies.entity_name', 2).toLowerCase(),
      header: {
        title: i18n.t('configurations.template_header_text'),
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: this.isFromClient ? 'configurations/clients/details' : 'configurations'
      },
      checkall: false,
      valuesCheckbox: {
        EmailAvisoNuevaEmitida: false,
        EmailAvisoNuevaRecibida: false,
        EmailAvisoCambioEstado: false,
        EmailTecnico: false,
        EnviarAvisos: false,
        Activo: false,
        Telefono: false,
        Direccion: false,
        CodigoPostal: false,
        Poblacion: false,
        Provincia: false,
        Pais: false,
        FaceEmail: false,
        FaceRecuperarEmail: false,
        // TuComunidadUsuario: false,
        // TuComunidadPassword: false,
        FirmarFacturae: false,
        FirmarAdjuntosExternos: false,
      },
      valuesAdd: {
        EmailAvisoNuevaEmitida: true,
        EmailAvisoNuevaRecibida: true,
        EmailAvisoCambioEstado: true,
        EmailTecnico: true,
      },
      form: {
        EmailAvisoNuevaEmitida: null,
        EmailAvisoNuevaRecibida: null,
        EmailAvisoCambioEstado: null,
        EmailTecnico: null,
        EnviarAvisos: false,
        Activo: true,
        Telefono: '',
        Direccion: '',
        CodigoPostal: '',
        Poblacion: '',
        Provincia: '',
        Pais: 'ESP',
        FaceEmail: '',
        FaceRecuperarEmail: false,
        // TuComunidadUsuario: '',
        // TuComunidadPassword: '',
        FirmarFacturae: false,
        FirmarAdjuntosExternos: false,
        IdCliente: null,
        IdPlantilla: 1
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        EmailAvisoNuevaEmitida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoNuevaRecibida: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoCambioEstado: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailTecnico: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        FaceEmail: [
          {
            required: false,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: true, validator: this.isEmailValidSingle, trigger: 'blur' }
        ],
        // TuComunidadUsuario: [
        //   {
        //     required: false,
        //     message: i18n.t('app.fill_data'),
        //     trigger: 'blur'
        //   },
        //   { validator: this.validateTuComunidadUser, trigger: 'blur' },
        // ],
        // TuComunidadPassword: [
        //   {
        //     required: false,
        //     message: i18n.t('app.fill_data'),
        //     trigger: 'blur'
        //   },
        //   { validator: this.validateTuComunidadPassword, trigger: 'blur' },
        // ],
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    titleLinkCompanies () {
      return this.modeTemplate ? i18n.t('configurations.link_template_to_entity', { entity: this.entity }) : i18n.t('configurations.apply_selected_to_entity', { entity: this.entity })
    },
    id () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : -1
    },
    isFromClient () {
      return this.id !== -1
    },
    isSpain: function () {
      return this.form.Pais.toUpperCase() === 'ESP'
    },
    listPaises: function () {
      return this.$store.getters['config/PAISES']
    },
    listProvincias: function () {
      return this.$store.getters['config/PROVINCIAS']
    },
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    valuesCheckbox: {
      deep: true,
      immediate: true,
      handler: 'watchValuesCheckboxHandler'
    },
    modeTemplate: function (value, oldValue) {
      if (!value) this.header.title = i18n.t('configurations.template_header_text_mode')
      else this.header.title = i18n.t('configurations.template_header_text')
    },
  },
  created: async function () {
    const breadcrumbs = []
    if (this.isFromClient) {
      breadcrumbs.push({
        path: this.role === 3 ? 'configurationssa' : 'configurations',
        name: i18n.t('configurations.header')
      })
      breadcrumbs.push({
        path: 'configurations/clients',
        name: i18n.t('clients.header')
      })
      const cabeceraStored = this.$store.getters['app/headerBreadCrumb']
      if (this.$store.getters['app/fromRouteName'] !== null && cabeceraStored) {
        breadcrumbs.push({ path: '', name: cabeceraStored })
      } else {
        const cliente = await this.downloadClientData(this.id)
        breadcrumbs.push({ path: '', name: cliente.Cliente.Nombre })
        this.$store.commit('app/setheaderBreadCrumb', cliente.Cliente.Nombre)
      }
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted: async function () {
    if (this.$route.params.data) {
      this.preSelectCompanies()
    } else {
      const template = await this.downloadData(this.id)
      this.setTemplate(template.respuesta)
    }

    this.header.url = this.isFromClient ? 'configurations/clients/details' : 'configurations'
  },
  methods: {
    preSelectCompanies () {
      this.enableEditCampos = false
      this.modeTemplate = false
      const data = this.$route.params.data
      if (data && data.companies) {
        setTimeout(() => {
          this.$refs.reftemplatelinkcompaniesdialog.changeSelectedCompanies(data.companies)
        }, 500)
      }
      this.togglePopoverRedirection()
    },
    togglePopoverRedirection: async function () {
      this.showPopoverRedirection = true
      setTimeout(() => {
        this.showPopoverRedirection = false
      }, 3000)
    },
    watchValuesCheckboxHandler: function () {
      const aux = this.valuesCheckbox
      const checkboxKeys = Object.keys(aux)
      this.checkall = true
      checkboxKeys.forEach(key => {
        if (!aux[key]) {
          this.checkall = false
          return false
        }
      })
    },
    toggleModeTemplate: function () {
      this.modeTemplate = !this.modeTemplate
    },
    changeAllCheckbox (value) {
      this.valuesCheckbox.EmailAvisoNuevaEmitida = value
      this.valuesCheckbox.EmailAvisoNuevaRecibida = value
      this.valuesCheckbox.EmailAvisoCambioEstado = value
      this.valuesCheckbox.EmailTecnico = value
      this.valuesCheckbox.EnviarAvisos = value
      this.valuesCheckbox.Activo = value
      this.valuesCheckbox.Telefono = value
      this.valuesCheckbox.Direccion = value
      this.valuesCheckbox.CodigoPostal = value
      this.valuesCheckbox.Poblacion = value
      this.valuesCheckbox.Provincia = value
      this.valuesCheckbox.Pais = value
      this.valuesCheckbox.FaceEmail = value
      this.valuesCheckbox.FaceRecuperarEmail = value
      // this.valuesCheckbox.TuComunidadUsuario = value
      // this.valuesCheckbox.TuComunidadPassword = value
      this.valuesCheckbox.FirmarFacturae = value
      this.valuesCheckbox.FirmarAdjuntosExternos = value
    },
    toggleDialogLink: function () {
      this.linkToCompaniesDialog = !this.linkToCompaniesDialog
    },
    applyLinkHandler: async function (companies) {
      if (this.modeTemplate) {
        this.submitFormAndUpdateCompanies('ruleForm', companies)
      } else {
        this.UpdateCompaniesWithSelected('ruleForm', companies)
      }
    },
    downloadClientData: async function (id) {
      let client = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idCliente: id
        }
        client = await getClient(params)
        if (client.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', client))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return client
    },
    watchFormHandler: function ({ certificate, send_alerts }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        callback(new Error(i18n.t('validation.email_multiple')))
      } else {
        callback()
      }
    },
    isEmailValidSingle: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmailSingle(value)) {
        callback(new Error(i18n.t('validation.email')))
      } else {
        callback()
      }
    },
    // validateTuComunidadUser: function (rule, value, callback) {
    //   if (!value && this.form.TuComunidadPassword) {
    //     return callback(new Error(i18n.t('validation.complete')))
    //   }
    //   callback()
    // },
    // validateTuComunidadPassword: function (rule, value, callback) {
    //   if (!value && this.form.TuComunidadUsuario) {
    //     return callback(new Error(i18n.t('validation.complete')))
    //   }
    //   callback()
    // },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            EmailTecnico: this.form.EmailTecnico,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            Telefono: this.form.Telefono,
            Direccion: this.form.Direccion,
            CodigoPostal: this.form.CodigoPostal,
            Poblacion: this.form.Poblacion,
            Provincia: this.form.Provincia,
            CodigoPais: this.form.Pais,
            FaceEmail: this.form.FaceEmail,
            FaceRecuperarEmail: this.form.FaceRecuperarEmail,
            // TuComunidadUsuario: this.form.TuComunidadUsuario,
            // TuComunidadPassword: this.form.TuComunidadPassword,
            FirmarFacturae: this.form.FirmarFacturae,
            FirmarAdjuntosExternos: this.form.FirmarAdjuntosExternos,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          const response = await updateCompanyTemplate({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    submitFormAndUpdateCompanies: function (formName, companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const params = {
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EmailTecnico: this.form.EmailTecnico,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            Telefono: this.form.Telefono,
            Direccion: this.form.Direccion,
            CodigoPostal: this.form.CodigoPostal,
            Poblacion: this.form.Poblacion,
            Provincia: this.form.Provincia,
            CodigoPais: this.form.Pais,
            FaceEmail: this.form.FaceEmail,
            FaceRecuperarEmail: this.form.FaceRecuperarEmail,
            // TuComunidadUsuario: this.form.TuComunidadUsuario,
            // TuComunidadPassword: this.form.TuComunidadPassword,
            FirmarFacturae: this.form.FirmarFacturae,
            FirmarAdjuntosExternos: this.form.FirmarAdjuntosExternos,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          const response = await updateCompanyTemplate({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.saved_template_msg'), 'success')
            const response = await applyCompanyTemplate({ idCliente: this.id }, companies)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.toggleDialogLink()
              this.doFeedback(i18n.t('feedback.success.updated_companies_msg'), 'success')
            }
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    UpdateCompaniesWithSelected: function (formName, companies) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const companyIds = companies.map(company => { return company.IdCIFEmpresa })
          const params = {
            idCIFEmpresas: companyIds,

            checkEmailTecnico: this.valuesCheckbox.EmailTecnico,
            checkEnviarAvisos: this.valuesCheckbox.EnviarAvisos,
            checkEmailAvisoNuevaEmitida: this.valuesCheckbox.EmailAvisoNuevaEmitida,
            checkEmailAvisoNuevaRecibida: this.valuesCheckbox.EmailAvisoNuevaRecibida,
            checkEmailAvisoCambioEstado: this.valuesCheckbox.EmailAvisoCambioEstado,
            checkActivo: this.valuesCheckbox.Activo,
            checkTelefono: this.valuesCheckbox.Telefono,
            checkDireccion: this.valuesCheckbox.Direccion,
            checkCodigoPostal: this.valuesCheckbox.CodigoPostal,
            checkPoblacion: this.valuesCheckbox.Poblacion,
            checkProvincia: this.valuesCheckbox.Provincia,
            checkCodigoPais: this.valuesCheckbox.Pais,
            checkFaceEmail: this.valuesCheckbox.FaceEmail,
            checkFaceRecuperarEmail: this.valuesCheckbox.FaceRecuperarEmail,
            // checkTuComunidadUsuario: this.valuesCheckbox.TuComunidadUsuario,
            // checkTuComunidadPassword: this.valuesCheckbox.TuComunidadPassword,
            checkFirmarFacturae: this.valuesCheckbox.FirmarFacturae,
            checkFirmarAdjuntosExternos: this.valuesCheckbox.FirmarAdjuntosExternos,

            addEmailTecnico: !this.valuesAdd.EmailTecnico,
            addEmailAvisoNuevaEmitida: !this.valuesAdd.EmailAvisoNuevaEmitida,
            addEmailAvisoNuevaRecibida: !this.valuesAdd.EmailAvisoNuevaRecibida,
            addEmailAvisoCambioEstado: !this.valuesAdd.EmailAvisoCambioEstado,

            EmailTecnico: this.form.EmailTecnico,
            EmailAvisoNuevaEmitida: this.form.EmailAvisoNuevaEmitida,
            EmailAvisoNuevaRecibida: this.form.EmailAvisoNuevaRecibida,
            EmailAvisoCambioEstado: this.form.EmailAvisoCambioEstado,
            EnviarAvisos: this.form.EnviarAvisos,
            Activo: this.form.Activo,
            Telefono: this.form.Telefono,
            Direccion: this.form.Direccion,
            CodigoPostal: this.form.CodigoPostal,
            Poblacion: this.form.Poblacion,
            Provincia: this.form.Provincia,
            CodigoPais: this.form.Pais,
            FaceEmail: this.form.FaceEmail,
            FaceRecuperarEmail: this.form.FaceRecuperarEmail,
            // TuComunidadUsuario: this.form.TuComunidadUsuario,
            // TuComunidadPassword: this.form.TuComunidadPassword,
            FirmarFacturae: this.form.FirmarFacturae,
            FirmarAdjuntosExternos: this.form.FirmarAdjuntosExternos,
            IdCliente: this.form.IdCliente,
            IdPlantilla: this.form.IdPlantilla,
          }
          this.toggleDialogLink()
          const response = await applyCompanyKeys({ idCliente: this.id }, params)
          if (response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.updated_companies_msg'), 'success')
          }
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    goBack: function () {
      if (this.isFromClient) this.$router.push({ name: 'configurations/clients/details', params: this.id })
      else this.$router.push({ name: 'companies' })
    },
    downloadData: async function (id) {
      try {
        this.$store.commit('setIsLoading', true)
        const template = await getCompanyTemplate({ idCliente: this.id })
        if (template.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', template))
        } else {
          return template
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setTemplate: function (template) {
      if (template) {
        this.form.EmailAvisoNuevaEmitida = template.EmailAvisoNuevaEmitida ? template.EmailAvisoNuevaEmitida : null
        this.form.EmailAvisoNuevaRecibida = template.EmailAvisoNuevaRecibida ? template.EmailAvisoNuevaRecibida : null
        this.form.EmailAvisoCambioEstado = template.EmailAvisoCambioEstado ? template.EmailAvisoCambioEstado : null
        this.form.EmailTecnico = template.EmailTecnico ? template.EmailTecnico : null
        this.form.EnviarAvisos = template.EnviarAvisos ? template.EnviarAvisos : null
        this.form.Activo = template.Activo ? template.Activo : null
        this.form.Telefono = template.Telefono ? template.Telefono : null
        this.form.Direccion = template.Direccion ? template.Direccion : null
        this.form.CodigoPostal = template.CodigoPostal ? template.CodigoPostal : null
        this.form.Poblacion = template.Poblacion ? template.Poblacion : null
        this.form.Provincia = template.Provincia ? template.Provincia : null
        this.form.Pais = template.CodigoPais ? template.CodigoPais : 'ESP'
        this.form.FaceEmail = template.FaceEmail ? template.FaceEmail : null
        this.form.FaceRecuperarEmail = template.FaceRecuperarEmail ? template.FaceRecuperarEmail : null
        // this.form.TuComunidadUsuario = template.TuComunidadUsuario ? template.TuComunidadUsuario : null
        // this.form.TuComunidadPassword = template.TuComunidadPassword ? template.TuComunidadPassword : null
        this.form.FirmarFacturae = template.FirmarFacturae ? template.FirmarFacturae : null
        this.form.FirmarAdjuntosExternos = template.FirmarAdjuntosExternos ? template.FirmarAdjuntosExternos : null
        this.form.IdCliente = template.idCliente ? template.idCliente : null
        this.form.IdPlantilla = template.IdPlantilla ? template.IdPlantilla : null
      }
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
  max-height: 100%;
}

</style>

<style lang="sass" scoped>
</style>
